import React from 'react'
import classNames from 'classnames'

interface RoundLinkProps {
  children: React.ReactNode
  href: string
  label: string
  className?: string
}

export const RoundLink: React.FC<RoundLinkProps> = ({
  children,
  href,
  label,
  className,
}) => (
  <a
    href={href}
    aria-label={label}
    className={classNames(
      'bg-white text-primary rounded-full w-11 h-11 flex justify-center items-center fill-current',
      className
    )}
  >
    {children}
  </a>
)
